import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {
  onGetPagedAllEmailTemplates,
  onCreateEmailTemplate,
  onDeleteEmailTemplate,
  onGetEmailTemplate,
  onUpdateEmailTemplate,
} from '../../../app/modules/send-email-system/components/email-templates/core/_requests'
import {onGetEmailParameters} from '../../../app/services/dataForComboBox/dataForComboBoxService'
interface EmailTemplateState {
  emailTemplates: any
  emailTemplate: any
  emailParameters: any
  isLoading: boolean
}
const initialState = {
  emailTemplates: [],
  emailTemplate: null,
  emailParameters: [],
  isLoading: true,
} as EmailTemplateState

export const fetchEmailParameters = createAsyncThunk(
  'emailTemplate/fetchEmailParameters',
  async () => {
    const data: any = await onGetEmailParameters()
    return data.data.result
  }
)

export const fetchEmailTemplates = createAsyncThunk(
  'emailTemplate/fetchEmailTemplates',
  async (param: any) => {
    const data: any = await onGetPagedAllEmailTemplates(param)
    return data.data.result
  }
)

export const fetchEmailTemplate = createAsyncThunk(
  'emailTemplate/fetchEmailTemplate',
  async (param: any) => {
    const data: any = await onGetEmailTemplate(param)
    return data.data.result
  }
)

export const updateEmailTemplate = createAsyncThunk(
  'emailTemplate/updateEmailTemplate',
  async (param: any) => {
    const data: any = await onUpdateEmailTemplate(param)
    return data.data
  }
)

export const createEmailTemplate = createAsyncThunk(
  'emailTemplate/createEmailTemplate',
  async (param: any) => {
    const data: any = await onCreateEmailTemplate(param)
    return data.data
  }
)

export const deleteEmailTemplate = createAsyncThunk(
  'emailTemplate/deleteEmailTemplate',
  async (param: any) => {
    const data: any = await onDeleteEmailTemplate(param)
    return data.data
  }
)

const emailTemplateSlice = createSlice({
  name: 'emailTemplate',
  initialState,
  reducers: {
    clearEmailTemplates: (state) => {
      state.emailTemplates = []
    },
    clearEmailTemplate: (state) => {
      state.emailTemplate = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchEmailTemplates.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchEmailTemplates.fulfilled, (state: any, action) => {
      state.emailTemplates = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchEmailTemplates.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchEmailTemplate.fulfilled, (state: any, action) => {
      state.emailTemplate = action.payload
    })
    builder.addCase(fetchEmailParameters.fulfilled, (state: any, action) => {
      state.emailParameters = action.payload.items
    })
  },
})

export const {clearEmailTemplates, clearEmailTemplate, activateLoading} = emailTemplateSlice.actions

export default emailTemplateSlice.reducer
